import request from '@/utils/request'
// 切換品牌/場館
export function GetBrandList(brandId) {
  return request({
    url: '/api/web/brand/list',
    method: 'get',
    params: {
      brandId: brandId
    }
  })
}
// 當下所在網址的品牌/場館 Id + 名稱
export function GetBrandSiteInfo(url) {
  return request({
    url: '/api/web/brand/get-brand-site-info',
    method: 'get',
    params: {
      url
    }
  })
}
// 品牌下其他場館
export function GetBrandSiteList(brandId) {
  return request({
    url: '/api/web/brand/site-list',
    method: 'get',
    params: {
      brandId: brandId
    }
  })
}
// 此品牌資訊+品牌下其他場館
export function GetBrandSiteListBrief(brandId, siteId) {
  return request({
    url: '/api/web/brand/site-list-brief',
    method: 'get',
    params: {
      brandId: brandId,
      siteId: siteId
    }
  })
}
// 場館資訊
export function GetSiteInfo(siteId) {
  return request({
    url: '/api/web/brand/site-info',
    method: 'get',
    params: {
      siteId
    }
  })
}
// 取得使用者須知
export function GetConsumerPolicy(brandId, siteId, consumerPolicy) {
  return request({
    url: '/api/web/brand/get-consumer-policy',
    method: 'get',
    params: {
      brandId,
      siteId,
      consumerPolicy
    }
  })
}